module.exports = __webpack_public_path__ + "img/jiantouRight.6825cd5e.svg";